window.app.directive('checkEmail', ($http) => {

    const setEmailConfirmedValidity = (scope, status) => {
        scope.bikFishForm ? scope.bikFishForm.email.$setValidity('partnerEmail', status) : "";
        scope.singleApp ? scope.singleApp.email.$setValidity('partnerEmail', status): "";
    };

    const userProcessHandler = (scope, modelValue, responseData) => {
        scope.userMailAgentLink = `http://${modelValue.split('@')[1]}`;

        if (responseData.isPartner) {
            setEmailConfirmedValidity(scope, false);
            return;
        } else {
            setEmailConfirmedValidity(scope, true);
        }
    };

    return {
        require: 'ngModel',
        link: (scope, element, attrs, ngModel) => {
            ngModel.$asyncValidators.checkEmail = (modelValue, viewValue) => {
                if (typeof scope.emailChecks[modelValue] !== 'undefined') {
                    return (new Promise((resolve, reject) => resolve(scope.emailChecks[modelValue])))
                        .then(response => {
                            userProcessHandler(scope, modelValue, response.data);
                        }).catch(err => console.log(err));
                } else {
                    return $http.post(attrs.checkEmail, {email: modelValue})
                        .then(response => {
                            scope.emailChecks[modelValue] = response;
                            userProcessHandler(scope, modelValue, response.data);
                        }
                    ).catch(err => console.log(err));
                }
            };
        }
    }
});



// WEBPACK FOOTER //
// src/js/controllers/bikfish/checkEmail.js